// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_mUB","cls2":"ProfileDropdown-cls2_qU2 ProfileDropdown-cls1_mUB"};